import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { setAlert } from '../../store/alert';
import { setLoggedIn, setUser } from '../../store/user';
import fetch from '../../utils/fetch';

function Signin() {
	useDocumentTitle('Sign In');

	const dispatch = useDispatch();
	const navigate = useNavigate()
	const webSettings = useSelector(state => state.webSettings.data);

	const [uname, setUsername] = useState('');
	const [pass, setPassword] = useState('');
	const [loading, setLoading] = useState(false);

	function submit(e) {
		e.preventDefault();
		if (loading) return;
		let res;
		if (uname.trim().length > 0 && uname.trim().length < 50) {
			if (pass.trim().length > 0 && pass.trim().length < 50) {
				setLoading(true);
				fetch
					.get('getLogin', {
						username: uname,
						password: pass,
					})
					.then(res => {
						setLoading(false);
						let data = res.list[0];
						if (data) {
							if (data.PASSWORD === '<PASSWORD-ACCEPTED>') {
								dispatch(setAlert('Login successful!'));
								dispatch(setUser(data));
								dispatch(setLoggedIn(true));
								navigate('/home');
							} else {
								dispatch(setAlert({ type: 'error', message: 'Wrong Password' }));
							}
						} else {
							dispatch(setAlert({ type: 'error', message: 'Account does not exist' }));
						}
					})
					.catch(err => {
						setLoading(false);
						dispatch(setAlert({ type: 'error', message: err.message }));
					});
				return;
			} else res = 'Enter a valid password';
		} else res = 'Enter a valid username';
		if (res) {
			dispatch(setAlert({ type: 'error', message: res }));
		}
	}

	return (
		<div className='sign-window shadow'>
			<div className='head'>
				<img className='logo' src={webSettings && webSettings.WEB_SITE_LOGO} alt='' />
				<h2>Sign In</h2>
			</div>
			<form className='body' onSubmit={submit}>
				<input onInput={e => setUsername(e.target.value)} className='input' type='text' id='uname' placeholder='Username' value={uname} />
				<input onInput={e => setPassword(e.target.value)} className='input' type='password' id='pass' placeholder='Password' value={pass} />
				<Link to='/reset' style={{ display: 'block', padding: '10px 0' }}>
					Forgot password?
				</Link>
				<button className='btn' type='submit'>
					{loading ? 'Loading...' : 'Sign In'}
				</button>
			</form>
			<div className='foot'>
				<p className=''>
					Don't have account? <Link to='/signup'>Request for account</Link>
				</p>
			</div>
		</div>
	);
}

export default React.memo(Signin);
